import { saveAs } from 'file-saver';

export const formRules = (field) => {
  // eslint-disable-next-line max-len
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const rules = [v => !!v || `${field} is required`];

  if (field === 'Email') {
    rules.push(
      v => emailRegex.test(v) || 'Email is not valid',
    );
  }

  return rules;
};

export const getBase64FileContent = file => new Promise((resolve, reject) => {
  const reader = new FileReader();

  reader.readAsDataURL(file);
  reader.onload = function onload(evt) {
    const content = evt.target.result;
    const result = {
      prefix: `${content.slice(0, content.indexOf('base64,'))}base64,`,
      content: content.slice(content.indexOf('base64,') + 7),
    };
    resolve(result);
  };
  reader.onerror = function onerror() {
    reject(new Error('Error occurred'));
  };
});

export const downloadCsvFile = (data, fileName, type) => {
  const hrefData = encodeURI(data).replace(/#/g, '%23');

  const hiddenElement = document.createElement('a');
  hiddenElement.href = `data:${type};charset=utf-8,${hrefData}`;
  hiddenElement.target = '_blank';
  hiddenElement.download = fileName;
  hiddenElement.click();
};

export const downloadFile = (url, fileName) => {
  saveAs(url, fileName);
};

export const base64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  let byteCharacters;

  try {
    byteCharacters = atob(b64Data);
  } catch (e) {
    b64Data = btoa(encodeURIComponent(b64Data).replace(/%([0-9A-F]{2})/g,
      (match, p1) => String.fromCharCode(`0x${p1}`)));
    byteCharacters = atob(b64Data);
  }

  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};

export const saveFile = (blob, fileName) => {
  saveAs(blob, fileName);
};

export const json2csv = (objArray, headers) => {
  const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
  let str = '';
  let line = '';

  if (!headers) {
    headers = Object.keys(array[0]).map(key => ({
      name: key,
      value: key,
    }));
  }

  headers.map((header) => {
    const value = `${header.name}`;
    line += `"${value.replace(/"/g, '""')}",`;

    return null;
  });

  line = line.slice(0, -1);
  str += `${line}\r\n`;

  for (let i = 0; i < array.length; i += 1) {
    // eslint-disable-next-line no-shadow
    let line = '';

    headers.map((header) => {
      const value = `${array[i][header.value]}`;
      if (value) {
        line += `"${value.replace(/"/g, '""')}",`;
      } else {
        line += ',';
      }

      return null;
    });

    line = line.slice(0, -1);
    str += `${line}\r\n`;
  }

  return str;
};

export const setQuery = (query, route, router) => {
  const obj = Object.assign({}, route.query);

  Object.keys(query).forEach((key) => {
    const value = query[key];
    if (value) {
      obj[key] = value;
    } else {
      delete obj[key];
    }
  });

  try {
    router.replace({
      ...router.currentRoute,
      query: obj,
    });
  } catch (err) {
    console.warn(err);
  }
};

export const toQueryString = (obj) => {
  const parts = [];
  for (const i in obj) {
    if (obj[i]) {
      parts.push(`${encodeURIComponent(i)}=${encodeURIComponent(obj[i])}`);
    }
  }

  return parts.join('&');
};



// WEBPACK FOOTER //
// ./src/helpers.js